import { render } from "./AiInputBar.vue?vue&type=template&id=1f5c1f24&scoped=true"
import script from "./AiInputBar.vue?vue&type=script&lang=js"
export * from "./AiInputBar.vue?vue&type=script&lang=js"

import "./AiInputBar.vue?vue&type=style&index=0&id=1f5c1f24&lang=scss&scoped=true"

import exportComponent from "/var/www/production/releases/343/listings.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5c1f24"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput,QIcon,QBtn,QTooltip});
